var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 706,
    height: 445,
    viewBox: "0 0 706 445",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.01 3.69553H175.005V18.4776H179.01V3.69553Z",
    fill: "#737374"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.625 0H188.621V14.7821H192.625V0Z",
    fill: "#737374"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.834 0H195.829V14.7821H199.834V0Z",
    fill: "#737374"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.834 44.3464H195.829V59.1285H199.834V44.3464Z",
    fill: "#737374"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.843 22.173H203.838V36.9551H207.843V22.173Z",
    fill: "#737374"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M207.843 46.1939H203.838V60.976H207.843V46.1939Z",
    fill: "#737374"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M199.834 92.3881H195.829V107.17H199.834V92.3881Z",
    fill: "#737374"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M207.843 116.409H203.838V131.191H207.843V116.409Z",
    fill: "#737374"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M199.834 206.949H195.829V221.731H199.834V206.949Z",
    fill: "#737374"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.625 116.409H188.621V131.191H192.625V116.409Z",
    fill: "#737374"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M179.01 27.7163H175.005V42.4984H179.01V27.7163Z",
    fill: "#737374"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.01 258.686H175.005V273.468H179.01V258.686Z",
    fill: "#737374"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M179.01 306.728H175.005V321.51H179.01V306.728Z",
    fill: "#737374"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M179.01 330.749H175.005V345.531H179.01V330.749Z",
    fill: "#737374"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.01 53.585H173.403V55.4328H179.01V53.585Z",
    fill: "#737374"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M200.635 75.7581H195.028V77.6058H200.635V75.7581Z",
    fill: "#737374"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M179.01 171.841H173.403V173.689H179.01V171.841Z",
    fill: "#737374"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M179.01 192.167H173.403V194.015H179.01V192.167Z",
    fill: "#737374"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M200.635 310.424H195.028V312.271H200.635V310.424Z",
    fill: "#737374"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M194.227 354.77H188.621V356.618H194.227V354.77Z",
    fill: "#737374"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M175.005 70.2153V73.9103H176.607V81.3015H175.005V84.9965H179.01V70.2153H175.005Z",
    fill: "#737374"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M188.621 44.3465V48.0415H190.223V55.4327H188.621V59.1277H192.626V44.3465H188.621Z",
    fill: "#737374"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M203.838 68.3665V72.0627H205.44V79.454H203.838V83.149H207.843V68.3665H203.838Z",
    fill: "#737374"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M203.838 140.43V144.125H205.44V151.516H203.838V155.211H207.843V140.43H203.838Z",
    fill: "#737374"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M203.838 164.45V168.146H205.44V175.538H203.838V179.233H207.843V164.45H203.838Z",
    fill: "#737374"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M203.838 90.5404V94.2354H205.44V101.627H203.838V105.323H207.843V90.5404H203.838Z",
    fill: "#737374"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M195.829 22.1729V25.8691H197.431V33.2592H195.829V36.9554H199.834V22.1729H195.829Z",
    fill: "#737374"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M199.834 140.43H195.829V155.212H199.834V140.43Z",
    fill: "#737374"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M199.834 184.776H195.829V199.558H199.834V184.776Z",
    fill: "#737374"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M195.829 162.603V166.298H197.431V173.689H195.829V177.385H199.834V162.603H195.829Z",
    fill: "#737374"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M188.621 68.3665V72.0627H190.223V79.454H188.621V83.149H192.626V68.3665H188.621Z",
    fill: "#737374"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M188.621 92.3878V96.084H190.223V103.474H188.621V107.17H192.626V92.3878H188.621Z",
    fill: "#737374"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M192.625 164.451H188.621V179.233H192.625V164.451Z",
    fill: "#737374"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M188.621 140.43V144.125H190.223V151.516H188.621V155.211H192.626V140.43H188.621Z",
    fill: "#737374"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M192.625 212.492H188.621V227.274H192.625V212.492Z",
    fill: "#737374"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M188.621 188.471V192.166H190.223V199.558H188.621V203.254H192.626V188.471H188.621Z",
    fill: "#737374"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M192.625 260.534H188.621V275.316H192.625V260.534Z",
    fill: "#737374"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M199.834 256.838H195.829V271.621H199.834V256.838Z",
    fill: "#737374"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M188.621 236.513V240.209H190.223V247.6H188.621V251.295H192.626V236.513H188.621Z",
    fill: "#737374"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M203.838 236.513V240.209H205.44V247.6H203.838V251.295H207.843V236.513H203.838Z",
    fill: "#737374"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M248.689 22.173H244.685V36.9551H248.689V22.173Z",
    fill: "#737374"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M248.689 46.1939H244.685V60.976H248.689V46.1939Z",
    fill: "#737374"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M248.689 116.409H244.685V131.191H248.689V116.409Z",
    fill: "#737374"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M244.685 68.3665V72.0627H246.287V79.454H244.685V83.149H248.689V68.3665H244.685Z",
    fill: "#737374"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M244.685 140.43V144.125H246.287V151.516H244.685V155.211H248.689V140.43H244.685Z",
    fill: "#737374"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M244.685 164.45V168.146H246.287V175.538H244.685V179.233H248.689V164.45H244.685Z",
    fill: "#737374"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M244.685 90.5404V94.2354H246.287V101.627H244.685V105.323H248.689V90.5404H244.685Z",
    fill: "#737374"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M244.685 236.513V240.209H246.287V247.6H244.685V251.295H248.689V236.513H244.685Z",
    fill: "#737374"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M192.625 308.576H188.621V323.358H192.625V308.576Z",
    fill: "#737374"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M199.834 280.859H195.829V295.641H199.834V280.859Z",
    fill: "#737374"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M192.625 371.4H188.621V386.182H192.625V371.4Z",
    fill: "#737374"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M199.834 327.053H195.829V341.836H199.834V327.053Z",
    fill: "#737374"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M188.621 284.555V288.25H190.223V295.641H188.621V299.337H192.626V284.555H188.621Z",
    fill: "#737374"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M188.418 429.8V433.495H190.02V440.886H188.418V444.581H192.423V429.8H188.418Z",
    fill: "#737374"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M236.676 0H232.671V14.7821H236.676V0Z",
    fill: "#737374"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M236.676 116.409H232.671V131.191H236.676V116.409Z",
    fill: "#737374"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M238.277 354.77H232.671V356.618H238.277V354.77Z",
    fill: "#737374"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M232.671 44.3465V48.0415H234.273V55.4327H232.671V59.1277H236.676V44.3465H232.671Z",
    fill: "#737374"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M232.671 68.3665V72.0627H234.273V79.454H232.671V83.149H236.676V68.3665H232.671Z",
    fill: "#737374"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M232.671 92.3878V96.084H234.273V103.474H232.671V107.17H236.676V92.3878H232.671Z",
    fill: "#737374"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M236.676 164.451H232.671V179.233H236.676V164.451Z",
    fill: "#737374"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M232.671 140.43V144.125H234.273V151.516H232.671V155.211H236.676V140.43H232.671Z",
    fill: "#737374"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M236.676 212.492H232.671V227.274H236.676V212.492Z",
    fill: "#737374"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M232.671 188.471V192.166H234.273V199.558H232.671V203.254H236.676V188.471H232.671Z",
    fill: "#737374"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M236.676 260.534H232.671V275.316H236.676V260.534Z",
    fill: "#737374"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M232.671 236.513V240.209H234.273V247.6H232.671V251.295H236.676V236.513H232.671Z",
    fill: "#737374"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M236.676 308.576H232.671V323.358H236.676V308.576Z",
    fill: "#737374"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M236.676 371.4H232.671V386.182H236.676V371.4Z",
    fill: "#737374"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M232.671 284.555V288.25H234.273V295.641H232.671V299.337H236.676V284.555H232.671Z",
    fill: "#737374"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M232.671 397.269V400.964H234.273V408.355H232.671V412.05H236.676V397.269H232.671Z",
    fill: "#737374"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M255.898 0H251.893V14.7821H255.898V0Z",
    fill: "#737374"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M255.898 116.409H251.893V131.191H255.898V116.409Z",
    fill: "#737374"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M257.499 354.77H251.893V356.618H257.499V354.77Z",
    fill: "#737374"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M251.893 44.3465V48.0415H253.495V55.4327H251.893V59.1277H255.897V44.3465H251.893Z",
    fill: "#737374"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M251.893 68.3665V72.0627H253.495V79.454H251.893V83.149H255.897V68.3665H251.893Z",
    fill: "#737374"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M251.893 92.3878V96.084H253.495V103.474H251.893V107.17H255.897V92.3878H251.893Z",
    fill: "#737374"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M255.898 164.451H251.893V179.233H255.898V164.451Z",
    fill: "#737374"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M251.893 140.43V144.125H253.495V151.516H251.893V155.211H255.897V140.43H251.893Z",
    fill: "#737374"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M255.898 212.492H251.893V227.274H255.898V212.492Z",
    fill: "#737374"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M251.893 188.471V192.166H253.495V199.558H251.893V203.254H255.897V188.471H251.893Z",
    fill: "#737374"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M255.898 260.534H251.893V275.316H255.898V260.534Z",
    fill: "#737374"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M251.893 236.513V240.209H253.495V247.6H251.893V251.295H255.897V236.513H251.893Z",
    fill: "#737374"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M255.898 308.576H251.893V323.358H255.898V308.576Z",
    fill: "#737374"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M255.898 371.4H251.893V386.182H255.898V371.4Z",
    fill: "#737374"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M251.893 284.555V288.25H253.495V295.641H251.893V299.337H255.897V284.555H251.893Z",
    fill: "#737374"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M251.893 397.269V400.964H253.495V408.355H251.893V412.05H255.897V397.269H251.893Z",
    fill: "#737374"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M195.829 371.4V375.095H197.431V382.486H195.829V386.181H199.834V371.4H195.829Z",
    fill: "#737374"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M195.829 395.421V399.116H197.431V406.507H195.829V410.202H199.834V395.421H195.829Z",
    fill: "#737374"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M175.005 116.409V120.104H176.607V127.495H175.005V131.191H179.01V116.409H175.005Z",
    fill: "#737374"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M175.005 210.645V214.34H176.607V221.731H175.005V225.426H179.01V210.645H175.005Z",
    fill: "#737374"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M175.005 234.665V238.361H176.607V245.752H175.005V249.447H179.01V234.665H175.005Z",
    fill: "#737374"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M175.005 282.707V286.402H176.607V293.794H175.005V297.489H179.01V282.707H175.005Z",
    fill: "#737374"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M175.005 351.074V354.77H176.607V362.161H175.005V365.856H179.01V351.074H175.005Z",
    fill: "#737374"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M175.005 371.4V375.095H176.607V382.486H175.005V386.181H179.01V371.4H175.005Z",
    fill: "#737374"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M220.657 3.69553H216.653V18.4776H220.657V3.69553Z",
    fill: "#737374"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M220.657 27.7163H216.653V42.4984H220.657V27.7163Z",
    fill: "#737374"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M220.657 53.585H215.051V55.4328H220.657V53.585Z",
    fill: "#737374"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M220.657 171.841H215.051V173.689H220.657V171.841Z",
    fill: "#737374"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M220.657 192.167H215.051V194.015H220.657V192.167Z",
    fill: "#737374"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M216.653 70.2153V73.9103H218.255V81.3015H216.653V84.9965H220.657V70.2153H216.653Z",
    fill: "#737374"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M216.653 116.409V120.104H218.255V127.495H216.653V131.191H220.657V116.409H216.653Z",
    fill: "#737374"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M216.653 210.645V214.34H218.255V221.731H216.653V225.426H220.657V210.645H216.653Z",
    fill: "#737374"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M266.31 164.451H262.305V179.233H266.31V164.451Z",
    fill: "#737374"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M266.31 188.471H262.305V203.254H266.31V188.471Z",
    fill: "#737374"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M266.309 214.34H260.703V216.188H266.309V214.34Z",
    fill: "#737374"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M266.309 332.597H260.703V334.444H266.309V332.597Z",
    fill: "#737374"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M266.309 352.922H260.703V354.77H266.309V352.922Z",
    fill: "#737374"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M262.305 230.97V234.665H263.907V242.056H262.305V245.752H266.31V230.97H262.305Z",
    fill: "#737374"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M262.305 277.164V280.86H263.907V288.25H262.305V291.946H266.31V277.164H262.305Z",
    fill: "#737374"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M262.305 371.4V375.095H263.907V382.486H262.305V386.181H266.31V371.4H262.305Z",
    fill: "#737374"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M279.124 3.69553H275.119V18.4776H279.124V3.69553Z",
    fill: "#737374"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M292.74 0H288.735V14.7821H292.74V0Z",
    fill: "#737374"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M299.948 0H295.943V14.7821H299.948V0Z",
    fill: "#737374"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M299.948 44.3464H295.943V59.1285H299.948V44.3464Z",
    fill: "#737374"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M307.957 22.173H303.952V36.9551H307.957V22.173Z",
    fill: "#737374"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M307.957 46.1939H303.952V60.976H307.957V46.1939Z",
    fill: "#737374"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M299.948 92.3881H295.943V107.17H299.948V92.3881Z",
    fill: "#737374"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M307.957 116.409H303.952V131.191H307.957V116.409Z",
    fill: "#737374"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M299.948 206.949H295.943V221.731H299.948V206.949Z",
    fill: "#737374"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M292.74 116.409H288.735V131.191H292.74V116.409Z",
    fill: "#737374"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M279.124 27.7163H275.119V42.4984H279.124V27.7163Z",
    fill: "#737374"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M279.124 258.686H275.119V273.468H279.124V258.686Z",
    fill: "#737374"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M279.124 306.728H275.119V321.51H279.124V306.728Z",
    fill: "#737374"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M279.124 330.749H275.119V345.531H279.124V330.749Z",
    fill: "#737374"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M279.124 53.585H273.518V55.4328H279.124V53.585Z",
    fill: "#737374"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M300.749 75.7581H295.142V77.6058H300.749V75.7581Z",
    fill: "#737374"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M279.124 171.841H273.518V173.689H279.124V171.841Z",
    fill: "#737374"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M279.124 192.167H273.518V194.015H279.124V192.167Z",
    fill: "#737374"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M300.749 310.424H295.142V312.271H300.749V310.424Z",
    fill: "#737374"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M294.341 354.77H288.735V356.618H294.341V354.77Z",
    fill: "#737374"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M275.119 70.2153V73.9103H276.722V81.3015H275.119V84.9965H279.124V70.2153H275.119Z",
    fill: "#737374"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M288.735 44.3465V48.0415H290.337V55.4327H288.735V59.1277H292.74V44.3465H288.735Z",
    fill: "#737374"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M303.953 68.3665V72.0627H305.554V79.454H303.953V83.149H307.957V68.3665H303.953Z",
    fill: "#737374"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M303.953 140.43V144.125H305.554V151.516H303.953V155.211H307.957V140.43H303.953Z",
    fill: "#737374"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M303.953 164.45V168.146H305.554V175.538H303.953V179.233H307.957V164.45H303.953Z",
    fill: "#737374"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M303.953 90.5404V94.2354H305.554V101.627H303.953V105.323H307.957V90.5404H303.953Z",
    fill: "#737374"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M295.943 22.1729V25.8691H297.545V33.2592H295.943V36.9554H299.948V22.1729H295.943Z",
    fill: "#737374"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M299.948 140.43H295.943V155.212H299.948V140.43Z",
    fill: "#737374"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M299.948 184.776H295.943V199.558H299.948V184.776Z",
    fill: "#737374"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M295.943 162.603V166.298H297.545V173.689H295.943V177.385H299.948V162.603H295.943Z",
    fill: "#737374"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M288.735 68.3665V72.0627H290.337V79.454H288.735V83.149H292.74V68.3665H288.735Z",
    fill: "#737374"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M288.735 92.3878V96.084H290.337V103.474H288.735V107.17H292.74V92.3878H288.735Z",
    fill: "#737374"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M292.74 164.451H288.735V179.233H292.74V164.451Z",
    fill: "#737374"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M288.735 140.43V144.125H290.337V151.516H288.735V155.211H292.74V140.43H288.735Z",
    fill: "#737374"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M292.74 212.492H288.735V227.274H292.74V212.492Z",
    fill: "#737374"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M288.735 188.471V192.166H290.337V199.558H288.735V203.254H292.74V188.471H288.735Z",
    fill: "#737374"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M292.74 260.534H288.735V275.316H292.74V260.534Z",
    fill: "#737374"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M299.948 256.838H295.943V271.621H299.948V256.838Z",
    fill: "#737374"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M288.735 236.513V240.209H290.337V247.6H288.735V251.295H292.74V236.513H288.735Z",
    fill: "#737374"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M303.953 236.513V240.209H305.554V247.6H303.953V251.295H307.957V236.513H303.953Z",
    fill: "#737374"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M348.804 22.173H344.799V36.9551H348.804V22.173Z",
    fill: "#737374"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M348.804 46.1939H344.799V60.976H348.804V46.1939Z",
    fill: "#737374"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M348.804 116.409H344.799V131.191H348.804V116.409Z",
    fill: "#737374"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M344.799 68.3665V72.0627H346.401V79.454H344.799V83.149H348.804V68.3665H344.799Z",
    fill: "#737374"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M344.799 140.43V144.125H346.401V151.516H344.799V155.211H348.804V140.43H344.799Z",
    fill: "#737374"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M344.799 164.45V168.146H346.401V175.538H344.799V179.233H348.804V164.45H344.799Z",
    fill: "#737374"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M344.799 90.5404V94.2354H346.401V101.627H344.799V105.323H348.804V90.5404H344.799Z",
    fill: "#737374"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M344.799 236.513V240.209H346.401V247.6H344.799V251.295H348.804V236.513H344.799Z",
    fill: "#737374"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M292.74 308.576H288.735V323.358H292.74V308.576Z",
    fill: "#737374"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M299.948 280.859H295.943V295.641H299.948V280.859Z",
    fill: "#737374"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M292.74 371.4H288.735V386.182H292.74V371.4Z",
    fill: "#737374"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M299.948 327.053H295.943V341.836H299.948V327.053Z",
    fill: "#737374"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M288.735 284.555V288.25H290.337V295.641H288.735V299.337H292.74V284.555H288.735Z",
    fill: "#737374"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M288.735 397.269V400.964H290.337V408.355H288.735V412.05H292.74V397.269H288.735Z",
    fill: "#737374"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M336.79 0H332.785V14.7821H336.79V0Z",
    fill: "#737374"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M336.79 116.409H332.785V131.191H336.79V116.409Z",
    fill: "#737374"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M338.392 354.77H332.785V356.618H338.392V354.77Z",
    fill: "#737374"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M332.785 44.3465V48.0415H334.387V55.4327H332.785V59.1277H336.79V44.3465H332.785Z",
    fill: "#737374"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M332.785 68.3665V72.0627H334.387V79.454H332.785V83.149H336.79V68.3665H332.785Z",
    fill: "#737374"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M332.785 92.3878V96.084H334.387V103.474H332.785V107.17H336.79V92.3878H332.785Z",
    fill: "#737374"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M336.79 164.451H332.785V179.233H336.79V164.451Z",
    fill: "#737374"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M332.785 140.43V144.125H334.387V151.516H332.785V155.211H336.79V140.43H332.785Z",
    fill: "#737374"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M336.79 212.492H332.785V227.274H336.79V212.492Z",
    fill: "#737374"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M332.785 188.471V192.166H334.387V199.558H332.785V203.254H336.79V188.471H332.785Z",
    fill: "#737374"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M336.79 260.534H332.785V275.316H336.79V260.534Z",
    fill: "#737374"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M332.785 236.513V240.209H334.387V247.6H332.785V251.295H336.79V236.513H332.785Z",
    fill: "#737374"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M336.79 308.576H332.785V323.358H336.79V308.576Z",
    fill: "#737374"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M336.79 371.4H332.785V386.182H336.79V371.4Z",
    fill: "#737374"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M332.785 284.555V288.25H334.387V295.641H332.785V299.337H336.79V284.555H332.785Z",
    fill: "#737374"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M234.955 417.121V420.816H236.557V428.207H234.955V431.902H238.96V417.121H234.955Z",
    fill: "#737374"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M356.012 0H352.007V14.7821H356.012V0Z",
    fill: "#737374"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M356.012 116.409H352.007V131.191H356.012V116.409Z",
    fill: "#737374"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M357.614 354.77H352.007V356.618H357.614V354.77Z",
    fill: "#737374"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M352.007 44.3465V48.0415H353.609V55.4327H352.007V59.1277H356.012V44.3465H352.007Z",
    fill: "#737374"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M352.007 68.3665V72.0627H353.609V79.454H352.007V83.149H356.012V68.3665H352.007Z",
    fill: "#737374"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M352.007 92.3878V96.084H353.609V103.474H352.007V107.17H356.012V92.3878H352.007Z",
    fill: "#737374"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M356.012 164.451H352.007V179.233H356.012V164.451Z",
    fill: "#737374"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M352.007 140.43V144.125H353.609V151.516H352.007V155.211H356.012V140.43H352.007Z",
    fill: "#737374"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M356.012 212.492H352.007V227.274H356.012V212.492Z",
    fill: "#737374"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M352.007 188.471V192.166H353.609V199.558H352.007V203.254H356.012V188.471H352.007Z",
    fill: "#737374"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M356.012 260.534H352.007V275.316H356.012V260.534Z",
    fill: "#737374"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M352.007 236.513V240.209H353.609V247.6H352.007V251.295H356.012V236.513H352.007Z",
    fill: "#737374"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M356.012 308.576H352.007V323.358H356.012V308.576Z",
    fill: "#737374"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M356.012 371.4H352.007V386.182H356.012V371.4Z",
    fill: "#737374"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M352.007 284.555V288.25H353.609V295.641H352.007V299.337H356.012V284.555H352.007Z",
    fill: "#737374"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M209.984 376.55V380.245H211.586V387.636H209.984V391.331H213.989V376.55H209.984Z",
    fill: "#737374"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M295.943 371.4V375.095H297.545V382.486H295.943V386.181H299.948V371.4H295.943Z",
    fill: "#737374"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M295.943 395.421V399.116H297.545V406.507H295.943V410.202H299.948V395.421H295.943Z",
    fill: "#737374"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M275.119 116.409V120.104H276.722V127.495H275.119V131.191H279.124V116.409H275.119Z",
    fill: "#737374"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M275.119 210.645V214.34H276.722V221.731H275.119V225.426H279.124V210.645H275.119Z",
    fill: "#737374"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M275.119 234.665V238.361H276.722V245.752H275.119V249.447H279.124V234.665H275.119Z",
    fill: "#737374"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M275.119 282.707V286.402H276.722V293.794H275.119V297.489H279.124V282.707H275.119Z",
    fill: "#737374"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M275.119 351.074V354.77H276.722V362.161H275.119V365.856H279.124V351.074H275.119Z",
    fill: "#737374"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M275.119 371.4V375.095H276.722V382.486H275.119V386.181H279.124V371.4H275.119Z",
    fill: "#737374"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M320.772 3.69553H316.767V18.4776H320.772V3.69553Z",
    fill: "#737374"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M320.772 27.7163H316.767V42.4984H320.772V27.7163Z",
    fill: "#737374"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M320.772 53.585H315.165V55.4328H320.772V53.585Z",
    fill: "#737374"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M320.772 171.841H315.165V173.689H320.772V171.841Z",
    fill: "#737374"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M320.772 192.167H315.165V194.015H320.772V192.167Z",
    fill: "#737374"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M316.767 70.2153V73.9103H318.369V81.3015H316.767V84.9965H320.772V70.2153H316.767Z",
    fill: "#737374"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M316.767 116.409V120.104H318.369V127.495H316.767V131.191H320.772V116.409H316.767Z",
    fill: "#737374"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M316.767 210.645V214.34H318.369V221.731H316.767V225.426H320.772V210.645H316.767Z",
    fill: "#737374"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M366.424 164.451H362.419V179.233H366.424V164.451Z",
    fill: "#737374"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M366.424 188.471H362.419V203.254H366.424V188.471Z",
    fill: "#737374"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M366.424 214.34H360.817V216.188H366.424V214.34Z",
    fill: "#737374"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M366.424 332.597H360.817V334.444H366.424V332.597Z",
    fill: "#737374"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M366.424 352.922H360.817V354.77H366.424V352.922Z",
    fill: "#737374"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M362.419 230.97V234.665H364.021V242.056H362.419V245.752H366.424V230.97H362.419Z",
    fill: "#737374"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M362.419 277.164V280.86H364.021V288.25H362.419V291.946H366.424V277.164H362.419Z",
    fill: "#737374"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M362.419 371.4V375.095H364.021V382.486H362.419V386.181H366.424V371.4H362.419Z",
    fill: "#737374"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M379.238 3.69553H375.234V18.4776H379.238V3.69553Z",
    fill: "#737374"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M392.854 0H388.849V14.7821H392.854V0Z",
    fill: "#737374"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M400.062 0H396.058V14.7821H400.062V0Z",
    fill: "#737374"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M400.062 44.3464H396.058V59.1285H400.062V44.3464Z",
    fill: "#737374"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M408.071 22.173H404.067V36.9551H408.071V22.173Z",
    fill: "#737374"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M408.071 46.1939H404.067V60.976H408.071V46.1939Z",
    fill: "#737374"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M400.062 92.3881H396.058V107.17H400.062V92.3881Z",
    fill: "#737374"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M408.071 116.409H404.067V131.191H408.071V116.409Z",
    fill: "#737374"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M400.062 206.949H396.058V221.731H400.062V206.949Z",
    fill: "#737374"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M392.854 116.409H388.849V131.191H392.854V116.409Z",
    fill: "#737374"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M379.238 27.7163H375.234V42.4984H379.238V27.7163Z",
    fill: "#737374"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M379.238 258.686H375.234V273.468H379.238V258.686Z",
    fill: "#737374"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M379.238 306.728H375.234V321.51H379.238V306.728Z",
    fill: "#737374"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M379.238 330.749H375.234V345.531H379.238V330.749Z",
    fill: "#737374"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M379.238 53.585H373.632V55.4328H379.238V53.585Z",
    fill: "#737374"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M400.863 75.7581H395.257V77.6058H400.863V75.7581Z",
    fill: "#737374"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M379.238 171.841H373.632V173.689H379.238V171.841Z",
    fill: "#737374"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M379.238 192.167H373.632V194.015H379.238V192.167Z",
    fill: "#737374"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M400.863 310.424H395.257V312.271H400.863V310.424Z",
    fill: "#737374"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M394.456 354.77H388.849V356.618H394.456V354.77Z",
    fill: "#737374"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M375.234 70.2153V73.9103H376.836V81.3015H375.234V84.9965H379.239V70.2153H375.234Z",
    fill: "#737374"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M388.849 44.3465V48.0415H390.451V55.4327H388.849V59.1277H392.854V44.3465H388.849Z",
    fill: "#737374"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M404.067 68.3665V72.0627H405.668V79.454H404.067V83.149H408.071V68.3665H404.067Z",
    fill: "#737374"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M404.067 140.43V144.125H405.668V151.516H404.067V155.211H408.071V140.43H404.067Z",
    fill: "#737374"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M404.067 164.45V168.146H405.668V175.538H404.067V179.233H408.071V164.45H404.067Z",
    fill: "#737374"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M404.067 90.5404V94.2354H405.668V101.627H404.067V105.323H408.071V90.5404H404.067Z",
    fill: "#737374"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M396.058 22.1729V25.8691H397.659V33.2592H396.058V36.9554H400.062V22.1729H396.058Z",
    fill: "#737374"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M400.062 140.43H396.058V155.212H400.062V140.43Z",
    fill: "#737374"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M400.062 184.776H396.058V199.558H400.062V184.776Z",
    fill: "#737374"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M396.058 162.603V166.298H397.659V173.689H396.058V177.385H400.062V162.603H396.058Z",
    fill: "#737374"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M388.849 68.3665V72.0627H390.451V79.454H388.849V83.149H392.854V68.3665H388.849Z",
    fill: "#737374"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M388.849 92.3878V96.084H390.451V103.474H388.849V107.17H392.854V92.3878H388.849Z",
    fill: "#737374"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M392.854 164.451H388.849V179.233H392.854V164.451Z",
    fill: "#737374"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M388.849 140.43V144.125H390.451V151.516H388.849V155.211H392.854V140.43H388.849Z",
    fill: "#737374"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M392.854 212.492H388.849V227.274H392.854V212.492Z",
    fill: "#737374"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M388.849 188.471V192.166H390.451V199.558H388.849V203.254H392.854V188.471H388.849Z",
    fill: "#737374"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M392.854 260.534H388.849V275.316H392.854V260.534Z",
    fill: "#737374"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M400.062 256.838H396.058V271.621H400.062V256.838Z",
    fill: "#737374"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M388.849 236.513V240.209H390.451V247.6H388.849V251.295H392.854V236.513H388.849Z",
    fill: "#737374"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M404.067 236.513V240.209H405.668V247.6H404.067V251.295H408.071V236.513H404.067Z",
    fill: "#737374"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M448.918 22.173H444.913V36.9551H448.918V22.173Z",
    fill: "#737374"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M448.918 46.1939H444.913V60.976H448.918V46.1939Z",
    fill: "#737374"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M448.918 116.409H444.913V131.191H448.918V116.409Z",
    fill: "#737374"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M444.913 68.3665V72.0627H446.515V79.454H444.913V83.149H448.918V68.3665H444.913Z",
    fill: "#737374"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M444.913 140.43V144.125H446.515V151.516H444.913V155.211H448.918V140.43H444.913Z",
    fill: "#737374"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M444.913 164.45V168.146H446.515V175.538H444.913V179.233H448.918V164.45H444.913Z",
    fill: "#737374"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M444.913 90.5404V94.2354H446.515V101.627H444.913V105.323H448.918V90.5404H444.913Z",
    fill: "#737374"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M444.913 236.513V240.209H446.515V247.6H444.913V251.295H448.918V236.513H444.913Z",
    fill: "#737374"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M392.854 308.576H388.849V323.358H392.854V308.576Z",
    fill: "#737374"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M400.062 280.859H396.058V295.641H400.062V280.859Z",
    fill: "#737374"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M392.854 371.4H388.849V386.182H392.854V371.4Z",
    fill: "#737374"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M400.062 327.053H396.058V341.836H400.062V327.053Z",
    fill: "#737374"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M388.849 284.555V288.25H390.451V295.641H388.849V299.337H392.854V284.555H388.849Z",
    fill: "#737374"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M205.444 422.193V425.888H207.045V433.279H205.444V436.974H209.448V422.193H205.444Z",
    fill: "#737374"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M436.904 0H432.9V14.7821H436.904V0Z",
    fill: "#737374"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M436.904 116.409H432.9V131.191H436.904V116.409Z",
    fill: "#737374"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M438.506 354.77H432.9V356.618H438.506V354.77Z",
    fill: "#737374"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M432.9 44.3465V48.0415H434.501V55.4327H432.9V59.1277H436.904V44.3465H432.9Z",
    fill: "#737374"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M432.9 68.3665V72.0627H434.501V79.454H432.9V83.149H436.904V68.3665H432.9Z",
    fill: "#737374"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M432.9 92.3878V96.084H434.501V103.474H432.9V107.17H436.904V92.3878H432.9Z",
    fill: "#737374"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M436.904 164.451H432.9V179.233H436.904V164.451Z",
    fill: "#737374"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M432.9 140.43V144.125H434.501V151.516H432.9V155.211H436.904V140.43H432.9Z",
    fill: "#737374"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M436.904 212.492H432.9V227.274H436.904V212.492Z",
    fill: "#737374"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M432.9 188.471V192.166H434.501V199.558H432.9V203.254H436.904V188.471H432.9Z",
    fill: "#737374"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M436.904 260.534H432.9V275.316H436.904V260.534Z",
    fill: "#737374"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M432.9 236.513V240.209H434.501V247.6H432.9V251.295H436.904V236.513H432.9Z",
    fill: "#737374"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M436.904 308.576H432.9V323.358H436.904V308.576Z",
    fill: "#737374"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M269.606 406.978H265.601V421.76H269.606V406.978Z",
    fill: "#737374"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M432.9 284.555V288.25H434.501V295.641H432.9V299.337H436.904V284.555H432.9Z",
    fill: "#737374"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M175.932 396.836V400.531H177.534V407.922H175.932V411.617H179.937V396.836H175.932Z",
    fill: "#737374"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M456.126 0H452.122V14.7821H456.126V0Z",
    fill: "#737374"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M456.126 116.409H452.122V131.191H456.126V116.409Z",
    fill: "#737374"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M457.728 354.77H452.122V356.618H457.728V354.77Z",
    fill: "#737374"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M452.122 44.3465V48.0415H453.723V55.4327H452.122V59.1277H456.126V44.3465H452.122Z",
    fill: "#737374"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M452.122 68.3665V72.0627H453.723V79.454H452.122V83.149H456.126V68.3665H452.122Z",
    fill: "#737374"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M452.122 92.3878V96.084H453.723V103.474H452.122V107.17H456.126V92.3878H452.122Z",
    fill: "#737374"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M456.126 164.451H452.122V179.233H456.126V164.451Z",
    fill: "#737374"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M452.122 140.43V144.125H453.723V151.516H452.122V155.211H456.126V140.43H452.122Z",
    fill: "#737374"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M456.126 212.492H452.122V227.274H456.126V212.492Z",
    fill: "#737374"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M452.122 188.471V192.166H453.723V199.558H452.122V203.254H456.126V188.471H452.122Z",
    fill: "#737374"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M456.126 260.534H452.122V275.316H456.126V260.534Z",
    fill: "#737374"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M452.122 236.513V240.209H453.723V247.6H452.122V251.295H456.126V236.513H452.122Z",
    fill: "#737374"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M456.126 308.576H452.122V323.358H456.126V308.576Z",
    fill: "#737374"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M216.259 318.229H212.254V333.011H216.259V318.229Z",
    fill: "#737374"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M452.122 284.555V288.25H453.723V295.641H452.122V299.337H456.126V284.555H452.122Z",
    fill: "#737374"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M177.068 422.193V425.888H178.669V433.279H177.068V436.974H181.072V422.193H177.068Z",
    fill: "#737374"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M396.058 371.4V375.095H397.659V382.486H396.058V386.181H400.062V371.4H396.058Z",
    fill: "#737374"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M219.064 404.443V408.138H220.666V415.529H219.064V419.224H223.069V404.443H219.064Z",
    fill: "#737374"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M375.234 116.409V120.104H376.836V127.495H375.234V131.191H379.239V116.409H375.234Z",
    fill: "#737374"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M375.234 210.645V214.34H376.836V221.731H375.234V225.426H379.239V210.645H375.234Z",
    fill: "#737374"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M375.234 234.665V238.361H376.836V245.752H375.234V249.447H379.239V234.665H375.234Z",
    fill: "#737374"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M375.234 282.707V286.402H376.836V293.794H375.234V297.489H379.239V282.707H375.234Z",
    fill: "#737374"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M375.234 351.074V354.77H376.836V362.161H375.234V365.856H379.239V351.074H375.234Z",
    fill: "#737374"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M375.234 371.4V375.095H376.836V382.486H375.234V386.181H379.239V371.4H375.234Z",
    fill: "#737374"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M420.886 3.69553H416.881V18.4776H420.886V3.69553Z",
    fill: "#737374"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M420.886 27.7163H416.881V42.4984H420.886V27.7163Z",
    fill: "#737374"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M420.886 53.585H415.279V55.4328H420.886V53.585Z",
    fill: "#737374"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M420.886 171.841H415.279V173.689H420.886V171.841Z",
    fill: "#737374"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M420.886 192.167H415.279V194.015H420.886V192.167Z",
    fill: "#737374"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M416.881 70.2153V73.9103H418.483V81.3015H416.881V84.9965H420.886V70.2153H416.881Z",
    fill: "#737374"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M416.881 116.409V120.104H418.483V127.495H416.881V131.191H420.886V116.409H416.881Z",
    fill: "#737374"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M416.881 210.645V214.34H418.483V221.731H416.881V225.426H420.886V210.645H416.881Z",
    fill: "#737374"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M466.538 164.451H462.533V179.233H466.538V164.451Z",
    fill: "#737374"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M466.538 188.471H462.533V203.254H466.538V188.471Z",
    fill: "#737374"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M466.538 214.34H460.932V216.188H466.538V214.34Z",
    fill: "#737374"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M466.538 332.597H460.932V334.444H466.538V332.597Z",
    fill: "#737374"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M466.538 352.922H460.932V354.77H466.538V352.922Z",
    fill: "#737374"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M462.533 230.97V234.665H464.135V242.056H462.533V245.752H466.538V230.97H462.533Z",
    fill: "#737374"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M462.533 277.164V280.86H464.135V288.25H462.533V291.946H466.538V277.164H462.533Z",
    fill: "#737374"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M463.1 304.283V307.978H464.702V315.369H463.1V319.064H467.104V304.283H463.1Z",
    fill: "#737374"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M342.028 199.44C342.888 199.44 343.585 197.831 343.585 195.848C343.585 193.864 342.888 192.255 342.028 192.255C341.168 192.255 340.471 193.864 340.471 195.848C340.471 197.831 341.168 199.44 342.028 199.44Z",
    fill: "#F2F2F2"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M342.547 195.848H341.509V252.123H342.547V195.848Z",
    fill: "#3F3D56"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M685.325 201.584C686.592 204.059 685.768 207.192 682.666 210.97C679.585 214.723 674.355 218.989 667.155 223.678C652.763 233.053 630.598 244.06 602.321 255.99C545.774 279.847 464.854 307.368 372.966 332.895C281.077 358.423 195.637 377.118 131.784 386.709C99.8543 391.505 73.3422 394.022 54.1289 393.983C44.5182 393.963 36.7661 393.304 31.0873 391.984C25.3702 390.656 21.9424 388.704 20.6752 386.23C19.4079 383.755 20.2321 380.622 23.3342 376.844C26.4154 373.091 31.6455 368.825 38.8447 364.136C53.2371 354.761 75.4017 343.754 103.679 331.824C160.226 307.967 241.146 280.446 333.034 254.919C424.923 229.391 510.363 210.696 574.216 201.105C606.146 196.309 632.658 193.792 651.871 193.832C661.482 193.851 669.234 194.51 674.913 195.83C680.63 197.158 684.058 199.11 685.325 201.584Z",
    stroke: "#A4A3A4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_8351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.206 266.454C392.147 269.397 396.775 273.339 401.11 278.2V285.632C398.995 284.967 390.921 282.21 387.733 277.849C384.048 272.809 383.393 265.158 386.461 263.242C387.261 262.745 388.232 262.683 389.297 262.956C392.656 265.188 395.869 267.895 398.937 271.049C400.025 272.593 400.698 274.559 401.11 276.546V276.64C397.14 271.533 392.472 268.221 387.206 266.454Z",
    fill: "#BB9EA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.958 220.802C391.899 223.746 396.527 227.687 400.862 232.548V234.246C400.447 234.115 399.806 233.906 399.017 233.619C395.471 229.736 391.43 227.12 386.958 225.62C390.086 227.483 393.09 229.747 395.973 232.392C392.924 231.036 389.359 229.027 387.484 226.462C387.286 226.191 387.097 225.918 386.918 225.643C383.765 220.807 383.557 215.503 386.461 213.691C389.53 211.775 394.91 214.489 398.595 219.527C400.725 222.443 401.323 226.967 401.445 230.259C401.249 230.497 401.055 230.74 400.862 230.988C396.892 225.881 392.224 222.569 386.958 220.802V220.802Z",
    fill: "#8F757C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.083 247.919V247.922C414.73 248.823 414.288 249.734 413.762 250.631C412.98 251.966 411.778 253.205 410.418 254.313C408.96 255.501 407.317 256.538 405.805 257.38C403.694 258.557 401.84 259.355 401.11 259.658V258.936C405.303 254.324 409.762 250.567 414.517 247.736C409.467 249.429 404.971 252.549 401.11 257.304V254.118C405.303 249.507 409.762 245.749 414.517 242.918C409.467 244.611 404.971 247.731 401.11 252.487V249.3C405.249 244.751 409.643 241.033 414.328 238.216C416.523 239.847 416.714 243.781 415.083 247.919Z",
    fill: "#A28D8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.194 280.125C311.896 280.125 327.868 265.367 327.868 247.163C327.868 228.958 311.896 214.201 292.194 214.201C272.492 214.201 256.521 228.958 256.521 247.163C256.521 265.367 272.492 280.125 292.194 280.125Z",
    fill: "#8D8572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.964 300.01C406.965 302.345 408.093 305.669 406.484 307.433C404.875 309.197 401.139 308.734 398.138 306.397C396.925 305.479 395.968 304.306 395.346 302.976L382.769 292.932L387.995 287.579L399.84 298.048C401.364 298.388 402.779 299.061 403.964 300.01Z",
    fill: "#B88565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.808 292.579L378.432 274.335L363.868 249.708L363.491 283.864L385.32 300.431L393.808 292.579Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.921 242.363L330.444 227.565L342.217 228.088L345.239 238.823L326.921 242.363Z",
    fill: "#B88565"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M326.921 242.363L330.444 227.565L342.217 228.088L345.239 238.823L326.921 242.363Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.039 231.536C343.319 231.536 349.22 226.083 349.22 219.357C349.22 212.631 343.319 207.178 336.039 207.178C328.76 207.178 322.858 212.631 322.858 219.357C322.858 226.083 328.76 231.536 336.039 231.536Z",
    fill: "#B88565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.143 224.06V224.06C330.143 224.06 328.814 224.048 326.048 223.573C323.282 223.098 328.084 229.07 328.084 229.07C315.068 224.048 319.233 211.31 319.233 211.31C306.024 208.976 311.558 198.126 311.558 198.126C311.558 198.126 315.912 190.362 329.297 190.856C342.683 191.35 336.359 203.548 336.359 203.548C345.08 203.563 346.061 210.826 346.061 210.826C346.061 210.826 342.917 211.188 337.204 212.528C331.491 213.868 330.143 224.06 330.143 224.06L330.143 224.06L330.143 224.06H330.143Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.621 237.703L329.025 236.631C329.025 236.631 318.434 237.766 316.696 239.263C314.958 240.761 310.985 247.413 310.985 247.413L319.675 254.296L329.621 237.703V237.703Z",
    fill: "#8B6045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.765 237.442C342.765 237.442 350.71 235.484 355.179 239.614C359.648 243.743 364.861 251.313 364.861 251.313L364.613 257.278L352.199 251.749L342.765 237.442V237.442Z",
    fill: "#8B6045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.79 236.631C344.79 236.631 355.179 233.19 361.882 240.531C368.586 247.872 370.572 271.042 370.572 271.042C370.572 271.042 385.717 313.941 381.993 314.4C378.268 314.859 355.541 316.127 355.541 316.127L347.73 269.436L344.254 236.631H344.79V236.631Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.916 277.924L318.434 286.183L352.199 288.477C352.199 288.477 350.958 281.573 352.199 279.061L320.916 277.924Z",
    fill: "#B88565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.027 317.262L337.03 341.565L345.957 339.252L352.143 337.62L354.641 316.573L335.027 317.262Z",
    fill: "#B88565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.254 236.631H329.025L316.696 251.772L319.427 282.742C319.427 282.742 325.634 281.136 334.323 281.136H352.944C352.944 281.136 350.213 273.107 353.689 269.895C357.165 266.684 354.682 251.772 354.682 251.772L344.254 236.631V236.631Z",
    fill: "#6C5044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.185 284.343L303.312 324.054C303.312 324.054 323.739 330.536 336.068 328.664C348.397 326.793 365.242 326.206 365.242 326.206L353.352 285.908L317.185 284.343V284.343Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.343 300.698C352.344 303.034 353.472 306.357 351.863 308.121C350.254 309.885 346.518 309.422 343.517 307.085C342.304 306.167 341.347 304.994 340.726 303.664L328.148 293.62L333.374 288.267L345.219 298.737C346.744 299.077 348.158 299.749 349.343 300.698V300.698Z",
    fill: "#B88565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.669 292.579L326.293 274.335L311.73 249.708L311.352 283.864L333.182 300.431L341.669 292.579Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.064 236.631C330.064 236.631 319.675 233.19 312.971 240.531C306.268 247.872 304.282 271.042 304.282 271.042C304.282 271.042 289.137 313.941 292.861 314.4C296.585 314.859 319.312 316.127 319.312 316.127L327.123 269.436L330.599 236.631H330.064V236.631Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.358 227.914H400.862V307.747H401.358V227.914Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.316 309.812C268.257 312.755 272.885 316.696 277.22 321.557V328.99C275.104 328.325 267.03 325.567 263.842 321.206C260.158 316.166 259.503 308.516 262.571 306.6C263.371 306.102 264.341 306.04 265.407 306.313C268.766 308.546 271.978 311.253 275.047 314.407C276.135 315.951 276.807 317.917 277.22 319.903V319.998C273.25 314.891 268.582 311.578 263.316 309.812V309.812Z",
    fill: "#A28D8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.068 264.16C268.008 267.103 272.636 271.045 276.971 275.906V277.603C276.557 277.473 275.916 277.264 275.127 276.977C271.581 273.093 267.539 270.478 263.068 268.978C266.196 270.84 269.2 273.105 272.083 275.75C269.034 274.394 265.469 272.384 263.594 269.82C263.396 269.549 263.207 269.276 263.028 269.001C259.875 264.165 259.666 258.861 262.571 257.049C265.64 255.133 271.02 257.847 274.705 262.885C276.835 265.8 277.433 270.324 277.555 273.616C277.359 273.855 277.165 274.098 276.971 274.346C273.001 269.239 268.334 265.927 263.068 264.16V264.16Z",
    fill: "#BB9EA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.193 291.277V291.279C290.84 292.181 290.398 293.092 289.872 293.989C289.09 295.324 287.888 296.563 286.527 297.671C285.07 298.859 283.426 299.896 281.914 300.738C279.804 301.915 277.949 302.713 277.22 303.016V302.293C281.413 297.682 285.872 293.924 290.627 291.094C285.577 292.787 281.08 295.907 277.22 300.662V297.476C281.413 292.865 285.872 289.107 290.627 286.276C285.577 287.969 281.08 291.089 277.22 295.845V292.658C281.358 288.109 285.753 284.39 290.438 281.573C292.633 283.204 292.824 287.139 291.193 291.277V291.277Z",
    fill: "#BB9EA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.468 271.272H276.971V351.105H277.468V271.272Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.01 326.91L321.203 345.752L334.965 342.263L334.277 329.004H324.644L315.01 326.91Z",
    fill: "#B88565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.542 285.169C278.455 285.169 281.627 282.394 281.627 278.97C281.627 275.546 278.455 272.771 274.542 272.771C270.629 272.771 267.457 275.546 267.457 278.97C267.457 282.394 270.629 285.169 274.542 285.169Z",
    fill: "#E3D2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.3 290.483C404.213 290.483 407.385 287.708 407.385 284.284C407.385 280.86 404.213 278.084 400.3 278.084C396.387 278.084 393.215 280.86 393.215 284.284C393.215 287.708 396.387 290.483 400.3 290.483Z",
    fill: "#E3D2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.199 304.653C279.644 304.653 281.627 302.671 281.627 300.225C281.627 297.779 279.644 295.797 277.199 295.797C274.753 295.797 272.771 297.779 272.771 300.225C272.771 302.671 274.753 304.653 277.199 304.653Z",
    fill: "#E3D2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.728 262.143C407.174 262.143 409.156 260.161 409.156 257.715C409.156 255.27 407.174 253.287 404.728 253.287C402.282 253.287 400.3 255.27 400.3 257.715C400.3 260.161 402.282 262.143 404.728 262.143Z",
    fill: "#E3D2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.199 331.222C279.644 331.222 281.627 329.636 281.627 327.679C281.627 325.723 279.644 324.137 277.199 324.137C274.753 324.137 272.771 325.723 272.771 327.679C272.771 329.636 274.753 331.222 277.199 331.222Z",
    fill: "#E3D2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.414 237.346C401.86 237.346 403.842 235.76 403.842 233.804C403.842 231.847 401.86 230.261 399.414 230.261C396.969 230.261 394.986 231.847 394.986 233.804C394.986 235.76 396.969 237.346 399.414 237.346Z",
    fill: "#E3D2AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_8351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159.641,
    height: 160.501,
    fill: "white",
    transform: "translate(256.521 190.833)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainIllustration);
export default __webpack_public_path__ + "static/media/Main_Illustration.3185baf56b395eec179f6f4f69ef21a3.svg";
export { ForwardRef as ReactComponent };